import React from 'react';
import '../template-file-css/document-file-template.css';



export const SLBC_Pcp = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='SLBC_Pcp' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>PCP Completed on:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Plan Meeting Date:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Effective Date:</span> </td>
                    </tr>
                </table>

                <table>
                    <tr><td className='w-250'><input type='date' id='txtPcpCompletedOn' name='txtPcpCompletedOn' className='add-only' /></td>
                        <td className='w-250'><input type='date' id='txtPlanMeetingDate' name='txtPlanMeetingDate' className='add-only' /></td>
                        <td className='w-250'><input type='date' id='txtEffectiveDate' name='txtEffectiveDate' className='add-only' /></td>

                    </tr>
                </table>

                <p className='w-750'><h3>Life Domains Assessed during Development of Person-Centered Plan</h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>Daily Life and Employment</span>
                    What a person does as part of everyday life - school, employment, volunteering, communication, routines, and skills.
                </p>
                <p className='w-750'><textarea id='txtDailyLifeAndEmployment' name='txtDailyLifeAndEmployment' className='add-only'></textarea></p>


                <p className='w-750'>
                    <span className='eleHeader'>Community Living</span>
                    Where and how someone lives - housing and living options, community access, transportation, home adaptation and modification.
                </p>
                <p className='w-750'><textarea id='txtCommunityLiving' name='txtCommunityLiving' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Safety and Security</span>
                    Staying safe and secure - finances, emergencies, relationships, neighborhood, well-being, decision making supports, legal rights, and issues.
                </p>
                <p className='w-750'><textarea id='txtSafetyAndSecurity' name='txtSafetyAndSecurity' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Healthy Living</span>
                    Managing and accessing health care and staying well - medical, mental health, behavioral, alcohol, tobacco and other drug use, medication management, life span development, exercise, wellness, and nutrition </p>
                <p className='w-750'> <textarea id='txtHealthyLiving' name='txtHealthyLiving' className='add-only'></textarea></p>



                <p className='w-750' >
                    <span className='eleHeader'>Social and Spirituality</span>
                    Building/strengthening friendships and relationships, leisure activities, personal networks, community inclusion, natural supports, cultural beliefs, and faith community.
                </p>
                <p className='w-750'><textarea id='txtSocialAndSpirituality' name='txtSocialAndSpirituality' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Citizenship and Advocacy</span>
                    Building valued roles, understanding personal rights, making choices, sexual orientation, self-identification, setting goals, assuming responsibility and driving how one's own life is lived.
                </p>
                <p className='w-750'><textarea id='txtCitizenshipAndAdvocacy' name='txtCitizenshipAndAdvocacy' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>What do you want to work on? What would you like accomplish</span>
                    Using the assessment of the Life Domains, use this information to determine what is most important to the individual right now? What is their vision of a good life?
                </p>
                <p className='w-750'><textarea id='txtWhatDoYouWantToWorkOn' name='txtWhatDoYouWantToWorkOn' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>What strengths do you currently have?</span>
                    These are the individualized, personal attributes, gifts, and skills a person possesses. Avoid what makes a “good client”. Good examples: good sense of humor, artistic, knowledgeable about gardening, good soccer player, stylish. Avoid: shows up for appointments, takes medications as prescribed, smiles a lot, follows directions.
                </p>
                <p className='w-750'><textarea id='txtWhatStrengthsDoYouCurrentlyHave' name='txtWhatStrengthsDoYouCurrentlyHave' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>What are the obstacles to meeting your goals?</span>
                    Help the individual identify the things that are getting in the way of meeting their goals and the resources they need to meet their goals. </p>
                <p><textarea id='txtWhatAreTheObstaclesToMeetingYourGoals' name='txtWhatAreTheObstaclesToMeetingYourGoals' className='add-only'></textarea></p>

                <p className='w-750'><center><h3>ACTION PLAN</h3></center><br />The Action Plan section of the PCP includes the individual's long-term goal, short-term goals, interventions, and timeframes.</p>

                <p className='w-750'>
                    <span className='eleHeader'>Long-Term Goal:</span>
                </p>
                <p className='w-750'><textarea id='txtLongTermGoal' name='txtLongTermGoal' className='add-only'></textarea></p>

                <p className='w-750'><center><h3>Short-Term SMART Goal</h3></center>
                    <span className='eleHeader'>Goal:</span></p>
                <p className='w-750'><textarea id='txtGoal' name='txtGoal' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Interventions - Provider(s): </span>
                </p>
                <p className='w-750'><textarea id='txtInterventionsProvider' name='txtInterventionsProvider' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Interventions - Individual and/or Natural Support Actions:</span>
                </p>
                <p className='w-750'><textarea id='txtInterventionsIndividualAndOrNaturalSupportActions' name='txtInterventionsIndividualAndOrNaturalSupportActions' className='add-only'></textarea> </p>


                <p className='w-750'><center><h3>Short-Term SMART Goal</h3></center>
                    <span className='eleHeader'>Goal:</span> </p>
                <p className='w-750'><textarea id='txtGoalOne' name='txtGoalOne' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Interventions - Provider(s): </span>
                </p>
                <p className='w-750'><textarea id='txtInterventionsProviderOne' name='txtInterventionsProviderOne' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Interventions - Individual and/or Natural Support Actions:</span>
                </p>
                <p className='w-750'><textarea id='txtInterventionsIndividualAndOrNaturalSupportActionsOne' name='txtInterventionsIndividualAndOrNaturalSupportActionsOne' className='add-only'></textarea></p>



                <p className='w-750'><center><h3>PLAN SIGNATURES</h3></center>
                    <span className='eleHeader'>I. PERSON RECEIVING SERVICES:</span>
                </p>

                <table>

                    <tr> <td className='w-750'>
                        <input type='checkbox' id='cbPersonReceivingServices_1' name='cbPersonReceivingServices_1' className='add-only' value='IConfirmAndAgreeWithMyInvolvementInTheDevelopment' />I confirm and agree with my involvement in the development of this PCP.  My signature means that I agree with the services/supports to be provided.</td>

                    </tr>
                    <tr> <td className='w-750'>
                        <input type='checkbox' id='cbPersonReceivingServices_2' name='cbPersonReceivingServices_2' className='add-only' value='IUnderstandThatIHaveTheChoiceOfServiceProvidersAndMayChangeService' />I understand that I have the choice of service providers and may change service providers at any time, by contacting the person responsible for this PCP.provided.</td>

                    </tr>
                    <tr> <td className='w-750'>
                        <input type='checkbox' id='cbPersonReceivingServices_3' name='cbPersonReceivingServices_3' className='add-only' value='ForIConfirmAndUnderstandThatIHaveTheChoiceOfSeekingCareInAnIntermediate' />For CAP-MR/DD services only, I confirm and understand that I have the choice of seeking care in an intermediate care facility for individuals with mental retardation instead of participating in the Community Alternatives Program for individuals with Mental Retardation/Developmental Disabilities (CAP-MR/DD).</td>

                    </tr>


                </table>
                <table>
                    <tr><td className='w-750'><span className='eleHeader'>Legally Responsible Person:</span></td>
                    </tr>
                    <tr><td className='w-750'><span><b>Self: </b></span>
                        <input type='radio' id='rbLegallyResponsiblePersonYes' name='rbLegallyResponsiblePerson' className='add-only' value='Yes' /> Yes &nbsp;
                        <input type='radio' id='rbLegallyResponsiblePersonNo' name='rbLegallyResponsiblePerson' className='add-only' value='No' /> No
                    </td>
                    </tr>
                </table>

                <table>
                    <tr><td className='w-750'>Person Receiving Services:
                        <span className='small'>(Required when person is his/her own legally responsible person)</span></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Signature</td>
                        <td className='small w-250'>Print Name</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <table>
                    <tr><td className='w-750'>Legally Responsible Person (Required if other than person receiving Services)</td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Signature</td>
                        <td className='small w-250'>Print Name</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Relationship to the Individual </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>II. PERSON RESPONSIBLE FOR THE PCP:</span>
                    <span className='small'>The following signature confirms the responsibility of the QP/LP for the development of this PCP.  The signature indicates agreement with the services/supports to be provided.
                    </span></p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Signature</td>
                        <td className='small w-250'>Name of Case Management Agency</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Child Mental Health Services Only:</span><br />
                    <span className='small'><b>For individuals who are less than 21 years of age (less than 18 for State funded services)</b> and who are receiving or in need of enhanced services and who are actively involved with the Department of Juvenile Justice and Delinquency Prevention or the adult criminal court system, the person responsible for the PCP must attest that he or she has completed the following requirements as specified below:</span>
                </p>

                <table> <tr> <td className='w-500'>
                    <input type='checkbox' id='cbChildMentalHealthServicesOnly_1' name='cbChildMentalHealthServicesOnly_1' className='add-only' value='MetChildFamilyTeam' />Met with the Child and Family Team - </td>
                    <td className='w-250'><input type='date' id='txtChildMentalHealthServices_1' name='txtChildMentalHealthServices_1' className='add-only' /></td>
                </tr>
                    <tr><td className='w-500'>
                        <input type='checkbox' id='cbChildMentalHealthServicesOnly_2' name='cbChildMentalHealthServicesOnly_2' className='add-only' value='ChildAndFamilyTeamMeatingScheduledFor' /><b>OR </b>Child and Family Team meeting scheduled for -</td>
                        <td className='w-250'><input type='date' id='txtChildMentalHealthServices_2' name='txtChildMentalHealthServices_2' className='add-only' /></td>
                    </tr>
                    <tr><td className='w-500'>
                        <input type='checkbox' id='cbChildMentalHealthServicesOnly_3' name='cbChildMentalHealthServicesOnly_3' className='add-only' value='AssignedACareManager' /><b>OR </b>Assigned a TASC Care Manager -</td>
                        <td className='w-250'><input type='date' id='txtChildMentalHealthServices_3' name='txtChildMentalHealthServices_3' className='add-only' /></td>
                    </tr>
                    <tr><td className='w-750'>
                        <input type='checkbox' id='cbChildMentalHealthServicesOnly_4' name='cbChildMentalHealthServicesOnly_4' className='add-only' value='ConferredWithTheClinicalStaffOfTheApplication' /><b>AND </b>conferred with the clinical staff of the applicable LME to conduct care coordination.</td>
                    </tr>
                    <tr>
                        <td className='w-750'>If the statements above do not apply, please check the box below and then sign as the Person Responsible for the PCP:</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbChildMentalHealthServicesOnly_5' name='cbChildMentalHealthServicesOnly_5' className='add-only' value='ThisChildIsNotActivelyInvolvedWithTheDepartmentOfJuvenileJusticeAnd' />This child is not actively involved with the Department of Juvenile Justice and Prevention or the adult criminal court system.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Signature:</b></td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Person responsible for the PCP</td>
                        <td className='small w-250'>Print Name</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                </table>

                <p className='w-750'><span className='eleHeader'>III. SERVICE ORDERS:</span>
                    <span className='small'>REQUIRED for all Medicaid funded services; RECOMMENDED for State funded services.</span>
                </p>
                <p className='750'><h3>{`(SECTION A):`}</h3><br />For services ordered by one of the Medicaid approved licensed signatories (see Instruction Manual). <br />
                    My signature below confirms the following: <span className='small'>(Check all appropriate boxes.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceOrders_1' name='cbServiceOrders_1' className='add-only' value='MedicalNecessityForServicesRequestedIsPresent' />{`Medical necessity for services requested is present, and constitutes the Service Order(s).`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <input type='checkbox' id='cbServiceOrder_2' name='cbServiceOrder_2' className='add-only' value='TheLicensedProfessionalWhoSignsThis' />{`The licensed professional who signs this service order has had direct contact with the individual.`}
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbServiceOrders_1Yes' name='rbServiceOrders_1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbServiceOrders_1No' name='rbServiceOrders_1' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr><td className='w-650'>
                        <input type='checkbox' id='cbServiceOrder_3' name='cbServiceOrder_3' className='add-only' value='TheLicensedProfessionalWhoSignsThisServices' />{`The licensed professional who signs this service order has reviewed the individual's assessment.`}</td>
                        <td className='w-100'>
                            <input type='radio' id='rbServiceOrders_2Yes' name='rbServiceOrders_2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbServiceOrders_2No' name='rbServiceOrders_2' className='add-only' value='No' /> No </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><b>Signature:</b></td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Name/Title Required</td>
                        <td className='small w-375'>Print Name</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>License #</td>
                        <td className='small w-375'>Date</td>
                    </tr>

                </table>

                <p className='w-750'><h3>{`(SECTION B):  For Qualified Professionals (QP) / Licensed Professionals (LP) ordering:`}</h3><br />
                    <ul>
                        <li>{`CAP-MR/DD or`}</li> <br />
                        <li>{`Medicaid Targeted Case Management (TCM) services (if not ordered in Section A)`}</li> <br />
                        <li>OR recommended for any state-funded services not ordered in Section A.</li></ul>
                </p>
                <p className='w-750'><span className='eleHeader'>My signature below confirms the following: </span>
                    <span className='small'>Check all appropriate boxes.</span>
                    Signatory in this section must be a Qualified or Licensed Professional.</p>

                <table>

                    <tr> <td className='w-750'>
                        <input type='checkbox' id='cbMySignatureBelowConfirmsTheFollowing_1' name='cbMySignatureBelowConfirmsTheFollowing_1' className='add-only' value='MedicalNecessityForTheRequestedIsPresentAnd' />Medical necessity for the CAP-MR/DD services requested is present, and constitutes the Service Order.</td>

                    </tr>
                    <tr> <td className='w-750'>
                        <input type='checkbox' id='cbMySignatureBelowConfirmsTheFollowing_2' name='cbMySignatureBelowConfirmsTheFollowing_2' className='add-only' value='MedicalNecessityForTheMedicaidServiceIsPresent' />Medical necessity for the Medicaid TCM service requested is present, and constitutes the Service Order.</td>

                    </tr>
                    <tr> <td className='w-750'>
                        <input type='checkbox' id='cbMySignatureBelowConfirmsTheFollowing_3' name='cbMySignatureBelowConfirmsTheFollowing_3' className='add-only' value='MedicalNecessityForTheStateFundedServices' />Medical necessity for the State-funded service(s) requested is present, and constitutes the Service Order</td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><b>Signature:</b></td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Name/Title Required</td>
                        <td className='small w-375'>Print Name</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>License #</td>
                        <td className='small w-375'>Date</td>
                    </tr>

                </table>
                <p className='w-750'><span className='eleHeader'>IV.  SIGNATURES OF OTHER TEAM MEMBERS PARTICIPATING IN DEVELOPMENT OF THE PLAN:</span>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>{`Other Team Member (Name/Relationship)`}</td>
                        <td className='small w-375'>Date</td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>{`Other Team Member (Name/Relationship)`}</td>
                        <td className='small w-375'>Date</td>
                    </tr>

                </table>



            </div>
        </form>

    )
}  
